import createIcon from '../../createIcon';

/**
 * @component @name SwapVerticalCircle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk02LjUgOUwxMCA1LjVMMTMuNSA5SDExVjEzSDlWOUg2LjVaTTE3LjUgMTVMMTQgMTguNUwxMC41IDE1SDEzVjExSDE1VjE1SDE3LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwapVerticalCircle = createIcon('SwapVerticalCircle', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM6.5 9L10 5.5L13.5 9H11V13H9V9H6.5ZM17.5 15L14 18.5L10.5 15H13V11H15V15H17.5Z',
      key: '1ahl16',
    },
  ],
]);

export default SwapVerticalCircle;
